import { useContext } from "react";
import { Button, List, Typography } from "antd";
import { DownloadOutlined, FileOutlined } from "@ant-design/icons";
import { ConfiguratorContext } from "../../context";
import { useQuoteContext } from "../../contexts/QuoteContext";
import useQuoteAssemblyDocuments from "../../swr/useQuoteAssemblyDocuments";
import { AssemblyDocument } from "../../api/models";

const AssemblyDocumentList = () => {
  const configurator = useContext(ConfiguratorContext);
  const { quote } = useQuoteContext();

  const isDealer = configurator.isDealerSales();
  const documentsAsync = useQuoteAssemblyDocuments({
    quoteId: isDealer ? undefined : quote?.quoteId,
    revisionId: quote?.currentRevisionId,
  });
  const documents = documentsAsync.data;

  if ( isDealer || !documents?.length ) return <></>;

  const handleDownload = (doc:AssemblyDocument) => {
    if ( doc.url ) {
      configurator.api.downloadFile( doc.url, { mimeType: doc.contentType, filename: doc.filename } );
    }
  };

  return <div style={{marginBottom: "1rem"}}>
    <Typography.Title level={5}>Assembly Documents</Typography.Title>
    <List
      size="small"
      dataSource={documents}
      renderItem={(doc) =>
        <List.Item
          actions={[<Button key="download" type="text" icon={<DownloadOutlined />} onClick={() => handleDownload(doc)} />]}
        >
          <List.Item.Meta
            avatar={<FileOutlined style={{fontSize: "150%"}} />}
            title={<Typography.Link onClick={() => handleDownload(doc)}>{doc.filename}</Typography.Link>}
            description={doc.assemblyLabel || doc.bom}
          />
        </List.Item>
      }
    />
  </div>;
};

export default AssemblyDocumentList;
